import React from "react";
import Textarea from "src/components/Textarea";
import { useIsMobile } from "src/hooks/useIsMobile";
import { DescriptionContainer } from "../styles";
import { WorkRequestCommentInputProps } from "../types";

const WorkRequestCommentInput = ({ comment, setFormData, isVerifyMode }: WorkRequestCommentInputProps) => {
  const { isMobile } = useIsMobile();

  return (
    <DescriptionContainer $isMobile={isMobile}>
      <label>Notes / Comments:</label>
      <Textarea
        countSymbols
        width="360px"
        value={comment || ""}
        disabled={isVerifyMode}
        placeholder="Add an optional note that will also appear in the Activity Log"
        onChange={(e) => setFormData((data) => ({ ...data, workRequestComment: e.target.value }))}
      />
    </DescriptionContainer>
  );
};

export default WorkRequestCommentInput;
